<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <user-menu></user-menu>

        <verify-permission
          controller="Reportes"
          action="getTotalPedidosByStatus"
        >
          <sidebar-item
            :link="{
              name: $t('app.modules.dashboard.title'),
              icon: 'now-ui-icons design_app',
              path: '/dashboard'
            }"
          >
          </sidebar-item>
        </verify-permission>

        <sidebar-item
          :link="{
            name: $t('app.nav_bar.admin.users_permissions'),
            icon: 'el-icon-user'
          }"
        >
          <verify-permission controller="Roles" action="getAllRoles">
            <sidebar-item
              :link="{
                name: 'Roles',
                path: '/admin/roles'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission controller="Usuarios" action="getUsuarios">
            <sidebar-item
              :link="{
                name: this.$t('app.modules.users.title'),
                icon: 'now-ui-icons users_single-02',
                path: '/admin/usuarios'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <!--<verify-permission controller="Roles" action="rolesVista">
            <sidebar-item
              :link="{
                name: this.$t('app.modules.corporate_roles.title'),
                icon: 'now-ui-icons business_badge',
                path: '/admin/roles_empresariales'
              }"
            >
            </sidebar-item>
          </verify-permission>-->

          <verify-permission
            controller="UsuarioTransportista"
            action="getUsuariosTransportistas"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.transport_users.title'),
                icon: 'now-ui-icons shopping_delivery-fast',
                path: '/admin/usuarios_transportistas'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission
            controller="Organizaciones"
            action="listaOrganizaciones"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.organizations.title'),
                icon: 'now-ui-icons shopping_delivery-fast',
                path: '/admin/organizaciones'
              }"
            >
            </sidebar-item>
          </verify-permission>
        </sidebar-item>

        <sidebar-item
          :link="{
            name: $t('app.nav_bar.admin.setting'),
            icon: 'el-icon-setting'
          }"
        >
          <verify-permission
            controller="MailConfiguration"
            action="getMailConfiguration"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.mail_configuration.title'),
                icon: 'now-ui-icons files_box',
                path: '/admin/configuracion_email'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <!--<verify-permission
            controller="ConfiguracionNotificaciones"
            action="getConfiguracionNotificaciones"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.configure_notifications.title'),
                icon: 'el-icon-open',
                path: '/admin/configuracion_notificaciones'
              }"
            >
            </sidebar-item>
          </verify-permission>-->

          <verify-permission
            controller="HorarioIngresoPedido"
            action="getHorarioIngresoPedido"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.order_entry_schedule.title'),
                icon: 'el-icon-alarm-clock',
                path: '/admin/horario_ingreso'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission
            controller="GrupoConfiguracionFasesEntrega"
            action="getConfigFasesDeEntrega"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.deliveryPhases.title'),
                icon: 'now-ui-icons shopping_delivery-fast',
                path: '/admin/delivery_phases'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission
            controller="UsuarioServicioCliente"
            action="getAllUSC"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.sac_mapping_settings.title'),
                icon: 'now-ui-icons shopping_delivery-fast',
                path: '/admin/configuracion_asignaciones_sac'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission
            controller="UsuarioLogistica"
            action="getAllUsuariosLogistica"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.logitic_mapping_settings.title'),
                icon: 'now-ui-icons shopping_delivery-fast',
                path: '/admin/configuracion_asignaciones_logistica'
              }"
            >
            </sidebar-item>
          </verify-permission>

        </sidebar-item>

        <sidebar-item
          :link="{
            name: $t('app.nav_bar.admin.catalogs'),
            icon: 'now-ui-icons education_agenda-bookmark'
          }"
        >
          <!--<verify-permission controller="UnidadMedida" action="getUnidadMedida">
            <sidebar-item
              :link="{
                name: $t('app.modules.measurements.title'),
                icon: 'now-ui-icons design-2_ruler-pencil',
                path: '/admin/medidas'
              }"
            >
            </sidebar-item>
          </verify-permission>-->

          <!--<verify-permission controller="TipoMoneda" action="getTipoMoneda">
            <sidebar-item
              :link="{
                name: $t('app.modules.currencies.title'),
                icon: 'now-ui-icons business_money-coins',
                path: '/admin/monedas'
              }"
            >
            </sidebar-item>
          </verify-permission>-->

          <!--<verify-permission
            controller="Notificaciones"
            action="GetTiposNotificaciones"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.notifications.title'),
                icon: 'now-ui-icons business_bulb-63',
                path: '/admin/notificaciones'
              }"
            >
            </sidebar-item>
          </verify-permission>-->

          <verify-permission
            controller="CategoriaProducto"
            action="getCategoria"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.category_product.title'),
                icon: 'now-ui-icons shopping_tag-content',
                path: '/admin/categorias'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission controller="Subcategoria" action="getSubcategoria">
            <sidebar-item
              :link="{
                name: $t('app.modules.subcategory_product.title'),
                icon: 'now-ui-icons shopping_tag-content',
                path: '/admin/subcategorias'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission
            controller="CaracteristicasProducto"
            action="getCaratacteristicasProducto"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.product_feature.title'),
                icon: 'now-ui-icons business_briefcase-24',
                path: '/admin/caracteristicas_producto'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission
            controller="TipoDocumentoPedido"
            action="getTipoDocumentoPedido"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.documentTypes.title'),
                icon: 'now-ui-icons files_single-copy-04',
                path: '/admin/tipos_documentos'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission
            controller="EmpresaTransportista"
            action="getEmpresasTransportistas"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.transport_company.title'),
                icon: 'now-ui-icons files_single-copy-04',
                path: '/admin/empresas_transportistas'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission
            controller="DeclinacionPedido"
            action="getDeclinacionPedido"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.reasons_declining_order.title'),
                icon: 'el-icon-document-checked',
                path: '/admin/motivos_declinacion'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission
            controller="PropiedadFamiliaProducto"
            action="getPropiedadFamiliaProducto"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.product_family_prop.title'),
                icon: 'now-ui-icons business_briefcase-24',
                path: '/admin/propiedades_familias_producto'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission
            controller="Incidencia"
            action="getTiposIncidencias"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.incidents.title'),
                icon: 'now-ui-icons shopping_delivery-fast',
                path: '/admin/tipos_incidencias'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission
            controller="TiposMotivoRechazo"
            action="getMotivosRechazoPartida"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.return_catalog.title'),
                icon: 'now-ui-icons shopping_delivery-fast',
                path: '/admin/motivivos_devolucion'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <!--<verify-permission
            controller="SolicitudCambioCliente"
            action="getSolicitudes"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.customer_information_change.title'),
                icon: 'now-ui-icons shopping_delivery-fast',
                path: '/admin/solicitud_cambio_cliente'
              }"
            >
            </sidebar-item>
          </verify-permission>-->

        </sidebar-item>

        <sidebar-item
          :link="{
            name: $t('app.nav_bar.admin.reports'),
            icon: 'now-ui-icons education_paper'
          }"
        >
          <verify-permission controller="Pedidos" action="ListaPedidos">
            <sidebar-item
              :link="{
                name: $t('app.modules.orders.title'),
                icon: 'now-ui-icons design-2_ruler-pencil',
                path: '/admin/reporte_pedidos'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission
            controller="Reclamaciones"
            action="getReclamaciones"
          >
            <sidebar-item
              :link="{
                name: $t('app.modules.complaints.title'),
                icon: 'now-ui-icons design-2_ruler-pencil',
                path: '/admin/reporte_reclamaciones'
              }"
            >
            </sidebar-item>
          </verify-permission>

          <verify-permission controller="Cotizacion" action="listaCotizaciones">
            <sidebar-item
              :link="{
                name: $t('app.modules.quotes.title'),
                icon: 'now-ui-icons design-2_ruler-pencil',
                path: '/admin/reporte_cotizaciones'
              }"
            >
            </sidebar-item>
          </verify-permission>
        </sidebar-item>

        <verify-permission controller="Prospectos" action="getProspectos">
          <sidebar-item
            :link="{
              name: this.$t('app.modules.candidates.title'),
              icon: 'el-icon-suitcase',
              path: '/admin/prospectos'
            }"
          >
          </sidebar-item>
        </verify-permission>

        <verify-permission
          controller="Comunicaciones"
          action="getComunicaciones"
        >
          <sidebar-item
            :link="{
              name: this.$t('app.modules.messages.title'),
              icon: 'now-ui-icons education_paper',
              path: '/admin/comunicados'
            }"
          >
          </sidebar-item>
        </verify-permission>

        <verify-permission controller="Reclamaciones" action="getReclamaciones">
          <sidebar-item
            :link="{
              name: this.$t('app.modules.complaints.title'),
              icon: 'el-icon-edit',
              path: '/admin/reclamaciones'
            }"
          >
          </sidebar-item>
        </verify-permission>

        <verify-permission controller="Pedidos" action="ListaPedidos">
          <sidebar-item
            :link="{
              name: this.$t('app.modules.orders.title'),
              icon: 'el-icon-box',
              path: '/admin/pedidos'
            }"
          >
          </sidebar-item>
        </verify-permission>

        <verify-permission controller="Productos" action="getAllProductos">
          <sidebar-item
            :link="{
              name: 'Productos',
              icon: 'now-ui-icons files_paper',
              path: '/admin/productos'
            }"
          >
          </sidebar-item>
        </verify-permission>

        <verify-permission controller="Clientes" action="getListadoClientesSAP">
          <sidebar-item
            :link="{
              name: 'Clientes',
              icon: 'now-ui-icons business_briefcase-24',
              path: '/admin/clientes'
            }"
          >
          </sidebar-item>
        </verify-permission>

        <verify-permission
          controller="FamiliasProducto"
          action="getFamiliasProducto"
        >
          <sidebar-item
            :link="{
              name: $t('app.modules.product_family.title'),
              icon: 'now-ui-icons shopping_tag-content',
              path: '/admin/familia_producto'
            }"
          >
          </sidebar-item>
        </verify-permission>

        <verify-permission
          controller="Pedidos"
          action="ListaPedidoPorTransportista"
        >
          <sidebar-item
            :link="{
              name: $t('app.modules.delivery.title'),
              icon: 'el-icon-truck',
              path: '/admin/entregas'
            }"
          >
          </sidebar-item>
        </verify-permission>

        <verify-permission
          controller="WebServiceTransportistas"
          action="addTracking"
        >
          <sidebar-item
            :link="{
              name: $t('app.modules.develop.title'),
              icon: 'el-icon-setting',
              path: '/admin/desarrollador'
            }"
          >
          </sidebar-item>
        </verify-permission>

        <verify-permission
          controller="WebServiceTransportistas"
          action="addTracking"
        >
          <sidebar-item
            :link="{
              name: $t('app.modules.check_order_tracking.title'),
              icon: 'now-ui-icons files_paper',
              path: '/admin/consulta_tracking_pedidos'
            }"
          >
          </sidebar-item>
        </verify-permission>

        <verify-permission
          controller="Cotizacion"
          action="listaCotizacionesByVendedor"
        >
          <sidebar-item
            :link="{
              name: $t('app.modules.quotes.title'),
              icon: 'el-icon-postcard',
              path: '/admin/cotizaciones'
            }"
          >
          </sidebar-item>
        </verify-permission>
        <verify-permission
          controller="CompraRapida"
          action="postEnviarInvitaciones"
        >
          <sidebar-item
            :link="{
              name: $t('app.modules.fast_ shopping.title'),
              icon: 'el-icon-shopping-cart-full',
              path: '/admin/compra_rapida'
            }"
          >
          </sidebar-item>
        </verify-permission>
        <verify-permission
          controller="EntregasOperadores"
          action="ListaEntregasOperador"
        >
          <sidebar-item
            :link="{
              name: $t('app.modules.operator_deliveries.title'),
              icon: 'el-icon-s-check',
              path: '/admin/entregas_operador'
            }"
          >
          </sidebar-item>
        </verify-permission>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
    <push-notification-box />
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import PushNotificationBox from "../../../components/PushNotificationBox.vue";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import { mapState } from "vuex";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    UserMenu,
    ZoomCenterTransition,
    PushNotificationBox
  },
  computed: {
    ...mapState(["user", "permissions"])
  },
  data() {
    return {};
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
